<template>
  <div class="sidebar-box category-box mt-6 p-1">
    <h6 class="mb-3 p-2" v-b-toggle.categories-filter>
      دسته بندی
      <b-icon icon="arrow-down-circle"></b-icon>
    </h6>

    <b-collapse id="categories-filter">
      <m-categories-wrapper :header="true">
        <template slot-scope="{categories}">
          <ul>
            <category-item @category="categorySetter" v-for="category in categories" :category="category"
                           :margin-right="0" :key="category.id"/>
          </ul>
        </template>
      </m-categories-wrapper>
    </b-collapse>


  </div>
</template>

<script>
import {categoryPanelProps} from '../CategoryPanelProps'
import {categoryMethods} from "../CategoriesMethods";
import CategoryItem from "./CategoryItem";

export default {
  name: "CategoriesPanel302",
  props: categoryPanelProps,
  components: {CategoryItem},
  methods: {
    ...categoryMethods,
    categorySetter(value) {
      this.$emit('category', value)
    }
  },
}
</script>

<style scoped>

.sidebar-box {
  border-radius: 10px;
  background: white;
  box-shadow: 0px 5px 25px rgba(218, 211, 211, 0.3);
  margin-bottom: 30px;
  border: 1px solid #F5F4F4;
}

.sidebar-box > form > input {
  width: 90%;
  border: none;
  background: transparent;

}

.sidebar-box ul li {
  padding-right: 25px;

  margin-bottom: 20px;
}

.sidebar-box ul li a {
  color: var(--dark);
}

</style>